/* global __APP_VERSION__ */

// Injected at build time by appVersionPlugin in vite.config.js ('dev' when running `vite`).
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev'

// Emitted next to index.html by the same plugin; not hashed so its URL is stable across deploys.
export const VERSION_FILE = '/version.json'

// Browser-specific messages thrown when a lazy `import()` targets a chunk that no longer exists
// on the server (Netlify removes the previous deploy's hashed assets). The SPA fallback answers
// with index.html, hence the "text/html" MIME error seen in the console.
const CHUNK_ERROR_PATTERNS = [
    /Failed to fetch dynamically imported module/i, // Chrome / Edge
    /error loading dynamically imported module/i, // Firefox
    /Importing a module script failed/i, // Safari
    /Expected a JavaScript.*module script/i, // MIME mismatch (text/html instead of JS)
    /Unable to preload CSS/i, // Vite preload helper
    /Loading chunk [\w-]+ failed/i, // webpack-style, kept for safety
]

export const isChunkLoadError = (error) => {
    if (!error) return false
    if (error.name === 'ChunkLoadError') return true
    const message = String(error.message || error)
    return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

export const fetchRemoteVersion = async () => {
    const response = await fetch(`${VERSION_FILE}?t=${Date.now()}`, { cache: 'no-store' })
    if (!response.ok) return null
    // Before the first deploy that ships version.json, the SPA fallback returns index.html here.
    if (!(response.headers.get('content-type') || '').includes('json')) return null
    const data = await response.json()
    return typeof data?.version === 'string' ? data.version : null
}

export const reloadApp = () => window.location.reload()

// TV / stream pages are full-screen displays; never overlay UI on them (same rule as CookiesConsent).
export const isPreviewPage = (pathname) => {
    const parts = pathname.split('/').filter((x) => x)
    return ['leaderboard', 'planning'].includes(parts[1]) && ['tv', 'stream'].includes(parts[2])
}
